import { createSelector } from 'reselect';

export const getComponentState = state => state.order;

export const getOrdering = createSelector(
    getComponentState,
    (state) => state.ordering
);
export const getShipName = createSelector(
    getComponentState,
    (state) => state.shipName
);
export const getShipAddress1 = createSelector(
    getComponentState,
    (state) => state.shipAddress1
);
export const getShipAddress2 = createSelector(
    getComponentState,
    (state) => state.shipAddress2
);
export const getShipCity = createSelector(
    getComponentState,
    (state) => state.shipCity
);
export const getShipState = createSelector(
    getComponentState,
    (state) => state.shipState
);
export const getShipZip = createSelector(
    getComponentState,
    (state) => state.shipZip
);
export const getShipPhone = createSelector(
    getComponentState,
    (state) => state.shipPhone
);
export const getShipEmail = createSelector(
    getComponentState,
    (state) => state.shipEmail
);
export const getShipNotes = createSelector(
    getComponentState,
    (state) => state.shipNotes
);
export const getBillName = createSelector(
    getComponentState,
    (state) => state.billName
);
export const getBillAddress1 = createSelector(
    getComponentState,
    (state) => state.billAddress1
);
export const getBillAddress2 = createSelector(
    getComponentState,
    (state) => state.billAddress2
);
export const getBillCity = createSelector(
    getComponentState,
    (state) => state.billCity
);
export const getBillState = createSelector(
    getComponentState,
    (state) => state.billState
);
export const getBillZip = createSelector(
    getComponentState,
    (state) => state.billZip
);
export const getBillPhone = createSelector(
    getComponentState,
    (state) => state.billPhone
);
export const getBillEmail = createSelector(
    getComponentState,
    (state) => state.billEmail
);
export const getBillPo = createSelector(
    getComponentState,
    (state) => state.billPo
);
export const getBillDepartment = createSelector(
    getComponentState,
    (state) => state.billDepartment
);
export const getBillCall = createSelector(
    getComponentState,
    (state) => state.billCall
);
export const getBillNotes = createSelector(
    getComponentState,
    (state) => state.billNotes
);
export const getSameAddress = createSelector(
    getComponentState,
    (state) => state.sameAddress
);
export const getCardNumber = createSelector(
    getComponentState,
    (state) => state.cardNumber
);
export const getNameOnCard = createSelector(
    getComponentState,
    (state) => state.nameOnCard
);
export const getExpirationMonth = createSelector(
    getComponentState,
    (state) => state.expirationMonth
);
export const getExpirationYear = createSelector(
    getComponentState,
    (state) => state.expirationYear
);
export const getSecurityNumber = createSelector(
    getComponentState,
    (state) => state.securityNumber
);
export const getReferenceFiles = createSelector(
    getComponentState,
    (state) => state.referenceFiles
);
export const getOrderId = createSelector(
    getComponentState,
    (state) => state.orderId
);